import React from 'react';

import { ProductDetailFlow } from './product-detail-flow';

export const ProductDetail: React.FC<React.PropsWithChildren<unknown>> = () => {
  return <ProductDetailFlow />;
};
